import React from 'react'
import ReactFlagsSelect from 'react-flags-select'

const Dropdown = ({ value, onInputChange, options }) => {
  const clonedOptions = structuredClone(options)
  const customLabels = clonedOptions.reduce((r, e) => {
    r[e.code] = e.code + ' ' + e.name + ' ' + e.dial_code
    return r
  })
  return (
    <ReactFlagsSelect
      selected={value}
      className="country-label"
      countries={clonedOptions?.map((ele) => ele.code)}
      customLabels={customLabels}
      placeholder="Code"
      searchable={true}
      selectedSize={14}
      showSelectedLabel={false}
      onSelect={onInputChange}
    />
  )
}

export default Dropdown
